import React from 'react';
import { Link } from 'react-router-dom';

import { SaveOnParts } from '../../SaveOnParts/SaveOnParts';
import "./StandardService.css"

 const StandardService = () => {
    return (

        <div className="services-Page">
            <main className="services-Page-main">

            <SaveOnParts/>

            <section className="services-Page-main__content">

                <h1 className="services-Page-main__content-mainTitle" >Standard Services-£60</h1>

                

                <h1 className="services-Page-main__content--partTitle">
                    Checks
                </h1>
                <ul className="services-Page-main__content--partParagraph">
                    <li>Check frame and forks for a potential immediate “write off” situation. i.e. bent or cracked(may require cleaning if you have not done this before I arrive)</li>

                    <li>Check for worn or broken parts – Wheel rims, wheel hubs, freehub, spokes, headset, bottom bracket, brake pads, tyres, pedals. I will advise replacement and cost of extra parts/labour where necessary</li>

                    <li>Check for normal alignment, basic operation of brake and gear cables and mechanisms.</li>
                
                </ul>



                <h1 className="services-Page-main__content--partTitle">
                    Wheel
                </h1>
                <ul className="services-Page-main__content--partParagraph">
                 <li>
                     (Fit)/Pump inner tubes to correct pressure (***Included FOC with “Regular” service)
                 </li>

                 <li>
                    True minor wobbles in wheels to allow for safe brake operation, clean rims.
                 </li>

                 <li>
                    Adjust if possible any play in hub bearings (replace if necessary)
                 </li>

                 <li>
                 Tighten axle nuts
                 </li>
                </ul>


                <h1 className="services-Page-main__content--partTitle">
                    Breaks
                </h1>
                <ul className="services-Page-main__content--partParagraph">
                    <li>
                    (Lubricate/replace brake calipers if necessary. ***Included FOC with “Regular” service)
                    </li>
                    <li>Fit/align pads</li>
                    <li>Set brake cable length</li>
                    <li>Balance brakes</li>
                    <li>Adjust lever position</li>
                </ul>


                <h1 className="services-Page-main__content--partTitle">
                    Gear
                </h1>

                <ul className="services-Page-main__content--partParagraph">
                    <li>
                        (Fit chain and cassette if necessary. ***Included FOC with “Regular” service)
                    </li>
                    <li>
                        Replace gear cables if necessary (May require re-wrap bar tape)
                    </li>
                    <li>
                        Index Front and rear gears.
                    </li>
                    <li>
                    Adjust calibration screws for safe operation
                    </li>
                </ul>





                <h1 className="services-Page-main__content--partTitle">
                   Crankeset/ <br /> Bottom bracket
                </h1>

                <ul className="services-Page-main__content--partParagraph">
                <li>
                Check crank bolts for correct torque
                </li>
                <li>Check pedals for play/smooth spinning</li>
                <li>Check bottom bracket for play and adjust where possible</li>
                <li>Check chainrings for wear, shark-toothing / broken teeth</li>
                </ul>




                <h1 className="services-Page-main__content--partTitle">
                Headset / <br /> steering / saddle
                </h1>
                <ul className="services-Page-main__content--partParagraph">
                    <li>
                    Check headset for play, or sticking, adjust if possible
                    </li>
                    <li>Check torque of stem and headset bolts</li>
                    <li>Adjust handlebar position/height.</li>
                    <li>Check saddle bolts for correct torque, lubricate and tighten seat-post.</li>
                </ul>

                
                
                <div style={{width:"100%"}}>
                    <button className="Page-main__content--Button" style={{justifySelf:"center",textAlign:"center"}}>
                    <Link to="/Booking">Book Now</Link>
                    </button>
                </div>


                


            </section>
                
            </main>
        </div>
    )
}

export default StandardService;

// export const StandardServices = () => {
//     return (
//         <div className="Services">
//         <main className="main-content">
//             <h2>Standard Services</h2>
//             <h3 className="title">Checks</h3>
//             {
//                 standardServices.map(data => 
//                 <ul className="service-list">
//                 <li className="list">{data.checks}</li>
//                 <br></br>
//                 <li className="list">{data.wheels}</li>
//                 </ul>)
//             }
//            <h3 className="title">Wheels</h3>


//         </main>
            
//         </div>
//     )
// }
